import React from 'react';
import styled from 'styled-components';

export const RequiredIndicator = styled(({ className }) => <span className={className}>*</span>)`
  color: var(--error-900);
  margin-left: 5px;
`;
